
import React, { Component } from 'react'
import { Image, Segment } from 'semantic-ui-react';
import { getCDNpath } from '../../../app/common/util';

const withdrawBank = getCDNpath('/static/images/withdrawToBankError.png');

export default class NotFullKYC extends Component {
    render() {
        return (
            <Segment className="no-content-segment" textAlign="center">
                <Image alt="Withdraw to bank disabled" centered src={withdrawBank} />
                <p style={{ fontStyle: 'italic' }}>You cannot withdraw any amount to bank as of now. <a target="_fcWithDrawToBankChromeTab321" href="https://support.freecharge.in/freecharge-wallet-related/how-do-i-withdraw-money-from-my-account">Why?</a></p>
            </Segment>
        )
    }
}